// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__11QZ1","title":"BackImages_title__3apKF","images":"BackImages_images__2p4mh"};